export default __webpack_public_path__ + "static/Vanderbilt-e26b3afa4a5bea6caacff9d6480840b6.svg";